import React from "react";

const FramePc = () => {
  return (
    <svg
      className="frame"
      xmlns="http://www.w3.org/2000/svg"
      width="536"
      height="535.994"
      viewBox="0 0 536 535.994"
    >
      <script xmlns="" />
      <script xmlns="" />
      <g id="그룹_1072" data-name="그룹 1072" transform="translate(-968 -1411)">
        <path
          id="패스_1321"
          data-name="패스 1321"
          d="M20.432,0V44.673H138.2V241.62h53.128V0Z"
          transform="translate(1312.675 1411)"
          fill="#fff"
        />
        <path
          id="패스_1322"
          data-name="패스 1322"
          d="M0,11.908v241.62H170.893V208.863H53.137V11.908Z"
          transform="translate(968 1693.466)"
          fill="#fff"
        />
      </g>
    </svg>
  );
};

export default FramePc;
